var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__login" }, [
    _c("a", {
      staticClass: "header__login-link",
      class: {
        "is-loggedin": _vm.loggedin,
      },
      domProps: { innerHTML: _vm._s(_vm.linkText) },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }